<ng-container *ngIf="mainForm !== undefined && control">
  <div [formGroup]="mainForm" class="inputDatepicker {{layoutModifier}}">
    <input *ngIf="range; else single" type="text" [formControlName]="controlName"
      [placeholder]="placeholder | translate" bsDaterangepicker [bsConfig]="config" [bsValue]="value" [isOpen]="false"
      #datepicker="bsDaterangepicker">

    <ng-template #single>
      <input type="text" [formControlName]="controlName" [placeholder]="placeholder | translate" bsDatepicker
        [bsConfig]="config" [bsValue]="value" [isOpen]="false" #datepicker="bsDatepicker">
    </ng-template>
  </div>
</ng-container>
